import type { ButtonHTMLAttributes, DetailedHTMLProps, FC } from 'react'
import './styles.css'

type ButtonProps = DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> & {
  variant: 'primary' | 'secondary'
  size?: 'regular' | 'compact'
}

export const Button: FC<ButtonProps> = ({
  children,
  className,
  size = 'regular',
  variant,
  ...htmlProps
}) => {
  return (
    <button
      {...htmlProps}
      className={`bmw-button bmw-button-${size} bmw-button-${variant}${className ? ` ${className}` : ''}`}
    >
      {children}
    </button>
  )
}
